import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableOptions,
} from "mui-datatables";
import AuthService from "../../auth/AuthService";
import {
  productDownload,
  annualMyBidProducts,
  getAnnualBidInfo,
  annualBidUrl,
  annualMyLatestBidsForUser,
  annualMyRecentBidsForUser,
  productUrl,
} from "../../../common/config/app.endpoints";
import Alert from "../../../common/elements/Alert";
import LoadingSpinner from "../../../common/elements/LoadingSpinner";
import { oAuth } from "../../../routes/basic/BasicAppRouter";
import {
  StyledButton,
  StyledModal,
} from "../../../common/materials/GenericStyleComponent";

import { MuiThemeProvider, useTheme } from "@material-ui/core/styles";
import update from "immutability-helper";
import moment from "moment";
import EllipsisText from "../../../common/elements/EllipsisText";
import {
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@material-ui/core";
import copy from "copy-to-clipboard";
import {
  faEdit,
  faHeart,
  faShareSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ColorLensIcon from "@material-ui/icons/ColorLens";
import { openJewelleryCertificateLinkPopup } from "../../../common/GenericFunctions";
import PubSub from "pubsub-js";
import AlertReadOnlyUser from "../../../common/elements/AlertReadOnlyUser";
import {
  convertedValue,
  convertedbuyItNowValue,
  getReturnMyLatestStoredBid,
} from "../../products/preview/TenderGenericFunc";
import { StyledButtonGray, StyledBuyitNow, StyledSelectAllButtonHeader } from "./DiamondProductStyle";
import { useTranslation } from "react-i18next";
import ProductBiddingUi from "./biddingUi/ProductBiddingUi";
import Countdown from "react-countdown";
import {
  StyledButtonView,
  StyledButtonViewFilter,
  Styledview,
} from "../../products/preview/TendorPreviewView";
import AnnualBidPopup from "../../products/preview/bidPopupComponent/AnnualBidPopup";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import AnnualActionPageSizeSelectorjwl from "../../core-grid/grid-actions/AnnualActionPageSizeSelectorjwl";
import { JwlIsMyBidstabSelected, setJwlIsMybids } from "../../../redux/slice/commanPagination/commanPaginationSlice";
import { resetGridProductIndexes, resetjewellerySelectAll, resetJwlIsGridView, selectedColorFilter, selectJwlGridView, setColorFilter, setGridProductIndexes, setjewellerySelectAll, setJwlIsGridView } from "../../../redux/slice/annual/commanAnnualSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { RootState } from "../../../redux/reducer";
import JwlProductGridDataParentjwl from "./mobileUi/JwlProductGridDataParentjwl";
import { StyledPageSizeSelectorContainer } from "../../core-grid/grid-data/CoreDataGridofProduct";
import ProductGridDataChildComponentMyBids from "./mobileUi/ProductGridDataChildComponentMyBids";
import { StyledContainer } from "./DiamondProductMyBids";
import BuyItNowconfirmation from "./BuyItNow/BuyItNowconfirmation";

const faEditProps = faEdit as IconProp;
const faHeartProps = faHeart as IconProp;
const faShareSquareProps = faShareSquare as IconProp;

const StyledHeaderContainer = styled(Grid)`
  padding-top: 0px;
`;

const StyledLayoutGridMain = styled(Grid)`
  .MuiIconButton-edgeEnd {
    display: contents !important;
    transition: width 5s !important;
  }
  .MuiAccordionSummary-root {
    min-height: 10px !important;
    transition: width 4s !important;
  }
  .MuiPaper-root {
    box-shadow: none !important;
  }
  .AccordionHeader {
    width: 100%;
    transition: width 1s;

    @keyframes fadeMe {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
    }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
      top: 48px;
      width: 100% !important;
    }
    ${(props) => props.theme.breakpoints.between("lg", "xl")} {
      .MuiAccordion-root.Mui-expanded:first-child {
        margin-top: -5px;
      }
    }
  }
  .AccordionHeaderscroll {
    position: fixed;
    z-index: 999;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
    transition: width 1s;
    z-index: 1000 !important;

    @keyframes fadeMe {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
    }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
      top: 48px;
      width: 100% !important;
    }
    ${(props) => props.theme.breakpoints.between("lg", "xl")} {
      .MuiAccordion-root.Mui-expanded:first-child {
        margin-top: -5px;
      }
    }
  }
`;

const StyledLayoutGrid = styled(Grid)`
  width: 100%;

  .MuiTableCell-root {
    padding: 5px;
    border: 1px solid lightgray;
    z-index: 0 impo;
  }
  .MuiToolbar-regular {
    min-height: 0px;
  }
  .MuiTableCell-head {
    background: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
    color: white;
    text-align: center;
    font-weight: 700;
    border: 1px solid lightgray;
  }

  .MuiTableCell-root {
    text-align: center;
  }

  .MuiTableCell-head .MuiButton-root {
    color: white;
    text-align: center;
    font-weight: 700;
  }
  .linkCss {
    text-decoration: underline;
    color: blue;
    cursor: pointer;
  }
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    // padding: 10px 10px;
    .MuiTableHead-root {
      display: flex !important;
    }
    .MuiTableCell-root {
      text-align: center;
      max-width: 400px;
      border: none;
    }
    .MuiTableHead-root {
      display: flex !important;
    }
  }
`;
const StyledBtnContainer = styled.div`
  text-align: center;
`;

const StyledCoreDataGridContainer = styled(Grid)``;
const StyledTextWrapper = styled(Grid)`
  margin: auto;
  text-align: center;
`;
const StyledActionBarContainer = styled(Grid)`
  padding: 10px;
  align-items: center;
  margin: 10px 0px 10px 0px;
  border-radius: 5px;
  box-shadow: 2px 0px 5px 2px ${(props) => props.theme.colors.base.lightGrey};
  justify-content: flex-end;
  &:focus {
    outline: none;
  }
`;

const StyledButtonHeader = styled.button`
  color: ${(props) => props.theme.colors.base.grey};
  font-size: 0.9em;
  padding: 0.4em;
  margin: 0.3em;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
  background: ${(props) => props.theme.colors.base.veryVeryLightGrey};
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 0.8em;
  }
`;


export const StyledshowAllButton = styled.div`
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 1em;
    margin-top: 0.5em;
  }
`;
export const StyeldShowAllcontainer = styled(Grid)`
  justify-content: flex-end;
`;
export const StyledShowAll = styled.button`
  color: ${(props) => props.theme.colors.base.black};
  border: none;
  font-size: 1em;
  padding: 0.6em;
  border-radius: 5px;
  margin-left: 5px;
  margin-top: 5px;
  background: ${(props) => props.theme.colors.base.lightGrey};
  background: White;
  border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
  cursor: pointer;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }
`;

interface IProps {
  auctionId: any;
  auctionUserId: any;
  productCart: any;
  annualData: any;
}

let data: any = {};
let totalElement: number = 0;
let page: number = 0;
let testno: number = 100;

let payload: any = {};
let startCount: number = 0;
let endCount: number = 20;
let endCountMob: number = 100;
let rowSelectedData: any;
let updatedRowData: any;
let updateRowIndex: any;
let auctionProductResult: any;
let seconds: any = "";

let filter: any = [];
let filteredValues: any = "";
let filteredParcelValues: any = "";
let body: any = [];
let auctionName: string = "";
let length: any;
let date: string | string[] = "";
let auctionDate: any;
const columnIndexes = {
  serialNo: 0,
  productId: 1,
  auctionUserId: 2,
  productEndDate: 5,
  productCode: 6,
  lab: 7,
  certificate: 8,
  description: 9,
  currency: 10,
  remarks: 11,
  notes: 12,
  peicePerCt: 13,
  myLatestBids: 14,
  currentBidPrice: 15,
  noOfBids: 16,
  rowColor: 17,
  exchangeRate: 18,
  noOfBidders: 21,
  currentBidValue: 17,
  hieghestBidValue: 18,
  watched: 22,
  sellerAuctionUserId: 23,
  previousHighestBidder: 25,
  productStartDate: 26,
  productExtended: 27,
  holdPreviousBidder: 28,
};

let details: any;
let indexsForBulkBidItems: any = [];
let myLatestBidForProduct: any = [];
let isAuctionUserId: boolean;
let isReadOnlyUser: any;
const initialState = {
  mouseX: null,
  mouseY: null,
};
interface Size {
  width: number | undefined;
  height: number | undefined;
}
let timeVal: any = 2000;
const JwlProductMyBids = (props: IProps) => {
  const { auctionId, productCart } = props;

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableSelectCell: {
          fixedHeader: {
            background: "white",
          },
          fixedLeft: {
            background: "white",
          },
        },
      },
    });

  const [mybidProducts, setmybidProducts] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [apiTimeout, setApiTimeout] = useState(false);
  const [onAction, setOnAction] = useState(false);

  const [userBlock, setUserBlock] = useState(false);
  const [optionValue, setOptionValue] = useState("");
  const [showTenderSlider, setshowTenderSlider] = useState(false);
  const [uiBoxView, setUiBoxView] = useState(false);
  const [showBulkBidPopup, setShowBulkBidPopup] = useState(false);
  const [showBulkBidButton, setShowBulkBidButton] = useState(false);
  const [isColorDataFilter, setIsColorDataFilter] = useState(false);
  const [isDataRefresh, setIsDataRefresh] = useState(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] = useState(false);
  const [isTableExpanded, setIsTableExpanded] = useState(false);
  const [shouldGetAllData, setShouldGetAllData] = useState(false);
  const [showAllProductButton, setShowAllProductButton] =
    useState<boolean>(false);

  const [currentProductId, setCurrentProductId] = useState<string>("");
  const [productdate, setProductStartDate] = useState<string>("");
  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  const [colorMybidsName, setColorMybidsName] = React.useState<string>("");
  const [totalAmount, setTotalAmount] = React.useState(0);
  const [totalAmountLabel, setTotalAmountLabel] = React.useState<string>("");
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [isSelectedRefresh, setIsSelectedRefresh] = useState<boolean>(false);
  const [isBuyItNowModal, setIsBuyItNowModal] = useState(false);
  const [currentProductData, setCurrentProductData] = useState(null);

  const Auth = new AuthService();
  const { t } = useTranslation();
  let history = useHistory();

  const eventSource: any = useRef<any>();
  const maxRetryCount = 2;
  const countRef = useRef(0);
  const jwlItemPerPageRefmybid = useRef(20);
  const selectPageUseRef = useRef(0);

  const maxCallApiCount = 1;
  const countAnnualRef = useRef(0);
  const secondTryAnnualRef = useRef(0);
  const dispatch: AppDispatch = useDispatch();
  const bufferTotalPay = useRef(0);
  let userCurrencyCode = localStorage.getItem("preferredCurrency");
  let userCurrencySymbol = localStorage.getItem("preferredCurrencySymbol");
  const isGridView: any = useSelector((state: RootState) =>
    selectJwlGridView(state)
  );
  const usdBufferTotalPay = useRef(0);
  const isMyBidstab: any = useSelector((state: RootState) =>
    JwlIsMyBidstabSelected(state)
  );
  const selectedColor: any = useSelector((state: RootState) =>
    selectedColorFilter(state)
  );

  useEffect(() => {
    dispatch(resetGridProductIndexes());
    dispatch(resetjewellerySelectAll());
    setIsLoading(true);
    //data table api calling
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);
    localStorage.removeItem("dropDownFilterVal");
    localStorage.removeItem("auctionUserId");
    dispatch(setJwlIsMybids({ isMybidstab: true }));

    getMyLatestBids(auctionId);
    getAllUpdatedData();

    setTimeout(() => {
      setIsDataRefresh(!isDataRefresh);
    }, 2000);
    return () => {
      if (eventSource.current !== undefined || eventSource.current !== null) {
        if (eventSource.current?.close !== undefined) {
          eventSource.current?.close();
        }
      }

      // PubSub.publish("jewellerySelectAllCheckBoxMybids", { isItemSelected: false, selectedIndexes: [] });
    };
  }, []);

  useEffect(() => {
    if (shouldGetAllData) {
      getAllUpdatedData();
      setShouldGetAllData(false);
    }
  }, [shouldGetAllData]);

  const getAllUpdatedData = () => {
    if (countRef.current < maxRetryCount) {
      eventSource.current = new EventSource(
        `${getAnnualBidInfo}?auctionId=${auctionId}`
      );
      eventSource.current.onmessage = (event: any) => {
        updatedRowData = JSON.parse(event.data);
        if (updatedRowData !== undefined) {
          if (updatedRowData.alive) {
            //This will listen only for events
          } else {
            if (props.auctionId === updatedRowData.auctionId) {
              updateRowIndex = auctionProductResult.findIndex(
                (product: any) => product.perId === updatedRowData.perId
              );
              // setTotalAmount(bufferTotalPay.current + updatedRowData.currentBidPrice);
              const mapping: any = {};
              if (
                auctionProductResult !== undefined &&
                auctionProductResult.length > 0
              ) {
                auctionProductResult.map((items: any) => {
                  mapping[items.perId] = {
                    watched: items.watched,
                  };
                });
              }

              var updatedArr: any;
              if (updateRowIndex !== -1) {
                updatedArr = update(auctionProductResult, {
                  $splice: [[updateRowIndex, 1, updatedRowData]],
                });
              }

              const arr = [...updatedArr];
              // auctionProductResult = updatedArr;
              arr.map((items: any) => {
                if (mapping[items.perId] !== undefined) {
                  items.watched = mapping[items.perId].watched;
                }
              });
              auctionProductResult = updatedArr;
              setmybidProducts(auctionProductResult);
              setShouldGetAllData(false);

              //update total amount of user pay
              bufferTotalPay.current =
                bufferTotalPay.current +
                updatedRowData.liveHighestBidIncreasedBy;
              usdBufferTotalPay.current =
                usdBufferTotalPay.current +
                updatedRowData.liveHighestBidIncreasedByInCurrencies[0].amount;
              let { currency } = updatedRowData;
              if (userCurrencyCode !== "JPY") {
                let conversion = new Intl.NumberFormat("us-en").format(
                  Math.round(usdBufferTotalPay.current)
                );
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(bufferTotalPay.current)
                );
                setTotalAmountLabel(
                  `${updatedRowData.currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`
                );
              } else {
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(bufferTotalPay.current)
                );
                setTotalAmountLabel(
                  `${updatedRowData.currency.symbol} ${conversions}`
                );
              }
            }
          }
        }
      };
      eventSource.current.onerror = (err: any) => {
        console.error("EventSource failed:", err);
        countRef.current = countRef.current + 1;
        setShouldGetAllData(true);
      };
    }
  };

  //Note: Get my All LatestBid using this Api
  const getMyLatestBids = (auctionId: string) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.getRequest(
        `${annualMyLatestBidsForUser}?auctionId=${auctionId}`,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            myLatestBidForProduct = response;
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        }
      );
    }
  };
  const getMyRecentBids = (auctionId: string, productObj: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${annualMyRecentBidsForUser}?auctionId=${auctionId}`,
        productObj,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            let arrayModify = response;
            arrayModify.concat(
              myLatestBidForProduct.filter(
                (x: any) =>
                  !arrayModify.find((m: any) => m.productId === x.productId)
              )
            );

            setIsSelectedRefresh(!isSelectedRefresh);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        }
      );
    }
  };

  const getTendorMybidsAucProducts = (
    auctionId: number | string,
    currentPage: number,
    ismob: boolean
  ) => {
    setOpenToast(false);
    body = [];
    filteredValues = localStorage.getItem("filteredValues");
    filteredValues = JSON.parse(filteredValues);

    if (filteredValues !== undefined) {
      if (filteredValues === null || filteredValues.length === 0) {
        filter = null;
      } else {
        filteredValues.map((item: any, index: number) => {
          if (item.name === "auctionId") {
            filteredValues.splice(index, 1);
          }
        });
        filter = filteredValues;
      }
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);

      if (filteredParcelValues !== undefined) {
        if (
          filteredParcelValues === null ||
          filteredParcelValues.length === 0
        ) {
          filter = null;
        } else {
          filteredParcelValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredParcelValues.splice(index, 1);
            }
          });
          filter = filteredParcelValues;
        }
      }
    }

    getBody(auctionId, currentPage, endCount, ismob);
  };

  const getTendorMybidsAucProductsFirst = (
    auctionId: number | string,
    currentPage: number,
    ismob: boolean
  ) => {
    setOpenToast(false);
    body = [];
    filteredValues = localStorage.getItem("filteredValues");
    filteredValues = JSON.parse(filteredValues);

    if (filteredValues !== undefined) {
      if (filteredValues === null || filteredValues.length === 0) {
        filter = null;
      } else {
        filteredValues.map((item: any, index: number) => {
          if (item.name === "auctionId") {
            filteredValues.splice(index, 1);
          }
        });
        filter = filteredValues;
      }
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);

      if (filteredParcelValues !== undefined) {
        if (
          filteredParcelValues === null ||
          filteredParcelValues.length === 0
        ) {
          filter = null;
        } else {
          filteredParcelValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredParcelValues.splice(index, 1);
            }
          });
          filter = filteredParcelValues;
        }
      }
    }
    setTimeout(() => {
      getBody(auctionId, currentPage, endCount, ismob);
    }, timeVal);
    if (timeVal <= 15000) {
      timeVal = timeVal + 2000;
    } else {
      timeVal = 2000;
    }
  };

  const getBody = (
    auctionId: string | number,
    currentPage: number,
    endValue: number,
    ismobile: boolean
  ) => {
    page = currentPage;
    if (ismobile) {
      startCount = page * endCount;
    } else {
      startCount = page * endValue;
    }
    data = {};

    filteredValues = localStorage.getItem("filteredValues");
    filteredValues = JSON.parse(filteredValues);

    if (localStorage.getItem("annualitemsPerPage") !== null) {
      let savedCount: any = localStorage.getItem("annualitemsPerPage");
      endCount = parseInt(savedCount);
      jwlItemPerPageRefmybid.current = endCount;
    } else {
      endCount = 20;
      jwlItemPerPageRefmybid.current = endCount;
    }

    if (localStorage.getItem("onlyMybidsCurrentStart") !== null) {
      let savedCount: any = localStorage.getItem("onlyMybidsCurrentStart");
      startCount = parseInt(savedCount);
      selectPageUseRef.current = startCount;
    } else {
      startCount = 0;
      selectPageUseRef.current = startCount;
      localStorage.setItem("onlyMybidsCurrentStart", "0");
    }
    //handle drop downfilter value

    if (
      localStorage.getItem("dropDownFilterVal") !== undefined &&
      localStorage.getItem("dropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("dropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (
      filter === null &&
      (filteredValues == null ||
        filteredValues === undefined ||
        filteredValues === "null" ||
        filteredValues.length === 0)
    ) {
      payload = {
        filters: {
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: auctionId,
            },
            {
              match: "exact",
              name: "parcelType",
              value: "Jewellery",
            },
          ],
        },
        page: {
          start: ismobile ? startCount : 0,
          count: ismobile ? endCount : isMyBidstab ? 5000 : endValue,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "createdDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "DESC",
              },
            ],
          },
        },
      };
    } else {
      body = filteredValues ? filteredValues : filter;
      body.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          body.splice(index, 1);
        }
      });

      payload = {
        filters: {
          or: body,
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: auctionId,
            },
          ],
        },
        page: {
          start: ismobile ? startCount : 0,
          count: ismobile ? endCount : isMyBidstab ? 5000 : endValue,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "createdDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "DESC",
              },
            ],
          },
        },
      };
    }

    callApi(payload);
    setIsTableExpanded(false);
  };

  const handleBidClick = (tableData: any) => {
    rowSelectedData = tableData.rowData;
    rowSelectedData = tableData.rowData;
    getProductsDetails(mybidProducts);
    setshowTenderSlider(true);
  };

  const getProductsDetails = (product: any) => {
    length = mybidProducts.length;
    product.map((items: any, index: any) => {
      if (items.perId === rowSelectedData[columnIndexes.productId]) {
        details = index;
      }
    });
    return details;
  };

  // Tender mobile ui
  const getBoxIndex = (boxIndex: any) => {
    length = mybidProducts.length;
    details = boxIndex;
    setshowTenderSlider(true);
  };

  const callApi = (payload: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${annualMyBidProducts}?auctionId=${props.auctionId}&rowColorState=${selectedColor}`,
        payload,
        (status: any, response: any) => {
          setIsLoading(false);
          if (status === 200) {
            auctionName = response?.results[0]?.auctionName;
            totalElement = response.totalElements;
            auctionProductResult = response.results;
            auctionDate = response?.results[0]?.auctionStartDate;
            const requestData: any = [];

            let totalpay = 0;
            let usdTotalPay = 0;
            //calculate total sum of current Bid Price
            if (
              response.additionalData !== undefined &&
              response.results.length !== 0
            ) {
              let { totalAmount, totalAmountUSD, totalAmountJPY } =
                response.additionalData;
              let { currency } = response.results[0];
              usdTotalPay = totalAmountUSD;
              totalpay = totalAmount;
              //get auction currency symbol
              if (userCurrencyCode !== "JPY") {
                let conversion = new Intl.NumberFormat("us-en").format(
                  Math.round(totalAmountUSD)
                );
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(totalAmount)
                );
                setTotalAmountLabel(
                  `${currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`
                );
              } else {
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(totalAmount)
                );
                setTotalAmountLabel(`${currency.symbol} ${conversions}`);
              }
            } else {
              setTotalAmountLabel(`-`);
              setmybidProducts(response.results);
            }

            bufferTotalPay.current = totalpay;
            usdBufferTotalPay.current = usdTotalPay;
            setTotalAmount(totalpay);

            setmybidProducts(response.results);
            if (response.totalElements >= 100) {
              setShowAllProductButton(true);
            } else {
              setShowAllProductButton(false);
            }
            for (var i = 0; i < response.totalElements; i++) {
              var obj = response.results[i];
              const { auctionUserId, rowColor, previousHighestBidder } = obj;
              if (previousHighestBidder === undefined) {
                if (auctionUserId !== props.auctionUserId) {
                  obj["sortingColorCode"] = 113;
                  obj["colorFilter"] = "WHITE";
                } else {
                  if (rowColor === "#FFEB9C") {
                    obj["sortingColorCode"] = 112;
                    obj["colorFilter"] = "ORANGE";
                  } else {
                    obj["sortingColorCode"] = 111;
                    obj["colorFilter"] = "PINK";
                  }
                }
              } else {
                if (props.auctionUserId === previousHighestBidder) {
                  obj["sortingColorCode"] = 111;
                  obj["colorFilter"] = "PINK";
                } else {
                  if (rowColor === "#FFEB9C") {
                    obj["sortingColorCode"] = 112;
                    obj["colorFilter"] = "ORANGE";
                  } else {
                    obj["sortingColorCode"] = 111;
                    obj["colorFilter"] = "PINK";
                  }
                }
              }
              requestData.push(obj);
            }
            countAnnualRef.current = 0;
            secondTryAnnualRef.current = 1;
            setmybidProducts(requestData);
            // setIsDataTableRefresh(!isDataTableRefresh);
            setColorMybidsName(selectedColor);
            setIsLoading(false);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  // Tender bulk bid popup
  const bulkBidPopupHandler = () => {
    setShowBulkBidPopup(true);
  };

  const handleBtnValue = (
    values: number,
    currentBidPrice: any,
    productId: any,
    myBidValues: any
  ) => {
    var data = [
      {
        bidIncreasedBy: values,
        bidPrice: currentBidPrice,
        auctionUserId: props.auctionUserId,
        auctionId: auctionId,
        productId: productId,
      },
    ];
    var dataProduct = [productId];
    let updateRowIndex = myLatestBidForProduct.findIndex(
      (product: any) => product.productId === myBidValues.productId
    );
    if (updateRowIndex === -1) {
      var myLatestBidForProductObjectData: any = [
        ...myLatestBidForProduct,
        myBidValues,
      ];
      myLatestBidForProduct = myLatestBidForProductObjectData;
    } else {
      var updatedArray = update(myLatestBidForProduct, {
        $splice: [[updateRowIndex, 1, myBidValues]],
      });
      myLatestBidForProduct = updatedArray;
    }
    bidProduct(data, dataProduct);
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const bulkBidHandler = (
    values: any[],
    myBidBulkValues: any,
    productids: any
  ) => {
    myLatestBidForProduct = myBidBulkValues;
    let obj: any = productids;
    bidProduct(values, obj);
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
    dispatch(resetGridProductIndexes());
    dispatch(resetjewellerySelectAll());
    // PubSub.publish("jewellerySelectAllCheckBoxMybids", { isItemSelected: false, selectedIndexes: [] });
    setIsSelected(false);
  };

  const bidProduct = (payloadBid: any, productObj: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        annualBidUrl,
        payloadBid,
        (status: any, response: any) => {
          if (status === 200) {
            setIsDataRefresh(!isDataRefresh);
            getMyRecentBids(auctionId, productObj);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const getTableBodyHeight = () => {
    var h = window.innerHeight;
    let heightOfInnerTable = h - 250;
    if (mybidProducts.length > 2) {
      return `${heightOfInnerTable}px`;
    } else {
      return `auto`;
    }
  };

  const options: MUIDataTableOptions = {
    filter: true,
    download: "false",
    print: "false",
    viewColumns: "false",
    count: totalElement,
    // page: page,
    pagination: false,
    serverSide: false,
    search: true,
    sort: true,
    rowsPerPage: endCount,
    rowsPerPageOptions: [0],
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    isRowSelectable: (dataIndex: any) => {
      const disableRowIndexsArray = getDisableRowIndex();
      return disableRowIndexsArray.includes(dataIndex) ? false : true;
    },
    customToolbarSelect: () => {
      return (
        <div className="mailIconDiv">
          <IconButton color="primary">
            <i className="zmdi zmdi-email"></i>
          </IconButton>
        </div>
      );
    },
    onChangePage: (currentPage: number) => {
      getTendorMybidsAucProducts(auctionId, currentPage, false);
      setIsLoading(true);
    },

    onSearchChange: () => {},
    setRowProps: (row: any) => {
      if (row[columnIndexes.previousHighestBidder] === undefined) {
        if (row[columnIndexes.holdPreviousBidder] === undefined) {
          if (row[columnIndexes.auctionUserId] !== props.auctionUserId) {
            return { style: { background: "white" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        } else {
          if (props.auctionUserId === row[columnIndexes.holdPreviousBidder]) {
            return { style: { background: "#ffeb9c" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        }
      } else {
        if (props.auctionUserId === row[columnIndexes.previousHighestBidder]) {
          return { style: { background: "#FBE4D5" } };
        } else {
          return { style: { background: row[columnIndexes.rowColor] } };
        }
      }
    },
    onRowSelectionChange: (
      currentRowsSelected: any,
      allRowsSelected: any,
      rowsSelected: any
    ) => {
      indexsForBulkBidItems = rowsSelected;
      setOpenToast(false);
      indexsForBulkBidItems.map((indexs: any) => {
        let {
          sellerAuctionUserId,
          previousHighestBidder,
          auctionUserId,
          holdPreviousBidder,
        } = mybidProducts[indexs];
        if (sellerAuctionUserId === props.auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        } else if (previousHighestBidder !== undefined) {
          if (props.auctionUserId === previousHighestBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (holdPreviousBidder !== undefined) {
          if (props.auctionUserId === holdPreviousBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (auctionUserId === props.auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        }
      });
      if (indexsForBulkBidItems.length >= 0) {
        setShowBulkBidButton(true);
      } else {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length === 0) {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length > 10) {
        setShowAlertMessage(
          `${t("common:Tender:validation:productSelection")}`
        );
        setAlertType("error");
        setOpenToast(true);
      }
    },
    tableBodyHeight: getTableBodyHeight(),
    textLabels: {
      body: {
        noMatch: `${t("common:preview:noProductFound")}`,
      },
    },
  };

  const onGridSelectionChange = (rowsSelected: any) => {
    indexsForBulkBidItems = rowsSelected;
    setOpenToast(false);
    if (indexsForBulkBidItems.length >= 0) {
      setShowBulkBidButton(true);
    } else {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length === 0) {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length > 10) {
      setShowAlertMessage(`${t("common:Tender:validation:productSelection")}`);
      setAlertType("error");
      setOpenToast(true);
    }
  };

  const boxColor = (items: any) => {
    const {
      auctionUserId,
      rowColor,
      previousHighestBidder,
      holdPreviousBidder,
    } = items;
    if (previousHighestBidder === undefined) {
      if (holdPreviousBidder === undefined) {
        if (auctionUserId !== props.auctionUserId) {
          return "white";
        } else {
          return rowColor;
        }
      } else {
        if (props.auctionUserId === holdPreviousBidder) {
          return "#ffeb9c";
        } else {
          return rowColor;
        }
      }
    } else {
      if (props.auctionUserId === previousHighestBidder) {
        return "#FBE4D5";
      } else {
        return rowColor;
      }
    }
  };

  const getDisableRowIndex = () => {
    return mybidProducts.map((items: any, index: number) => {
      if (items.sellerAuctionUserId === props.auctionUserId) {
        return index;
      } else if (items.previousHighestBidder !== undefined) {
        if (props.auctionUserId === items.previousHighestBidder) {
          return index;
        }
      } else if (items.holdPreviousBidder !== undefined) {
        if (props.auctionUserId === items.holdPreviousBidder) {
          return index;
        }
      } else if (items.auctionUserId === props.auctionUserId) {
        return index;
      }
    });
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "serialNo",
      label: "Serial No",
      options: {
        filter: true,
        sort: true,
        display: true,
        filterType: "textField",
        sortThirdClickReset: true,
        sortDescFirst: true,
      },
    },
    {
      name: "perId",
      label: "Product Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "auctionUserId",
      label: "Auction User Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "buyItNow",
      label: "Buy it now",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          style: {
            background: "#E14843",
            color: "white",
            textAlign: "center",
          },
        }),
        setCellProps: () => ({
          style: { minWidth: "90px", maxWidth: "100px" },
        }),
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = mybidProducts[rowIndex];
          return (
            <div>
              <span>
                {convertedbuyItNowValue(
                  val.currency,
                  val.buyItNow,
                  val.exchangeRates[0].rate
                )}
              </span>
              <StyledBtnContainer>
                {val.buyItNow === 0 || val.sellerAuctionUserId === props.auctionUserId || isReadOnlyUser || val.buyItNow < val.currentBidPrice ? (
                  <StyledBuyitNow
                    style={{ color: "black", backgroundColor: "lightgrey" }}
                  >
                    Buy Now
                  </StyledBuyitNow>
                ) : (
                  <StyledBuyitNow
                    onClick={() => {
                      setCurrentProductData(val);
                    }}
                  >
                    Buy Now
                  </StyledBuyitNow>
                )}
              </StyledBtnContainer>
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: `${t("common:Tender:tableColumnNames:ActionsTender")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                justifyContent: "center",
              }}
            >
              <div
                title={`Note`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  openProductDetail(
                    auctionId,
                    tableMeta.rowData[1],
                    tableMeta.rowData[columnIndexes.productStartDate]
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faEditProps}
                  style={{ color: "#014a99" }}
                />
              </div>
              <div
                title={`Add Product into Wishlist`}
                style={{ cursor: "pointer" }}
              >
                {isReadOnlyUser ? (
                  <FontAwesomeIcon
                    icon={faHeartProps}
                    style={{ color: "gray" }}
                    onClick={() => {
                      renderReadOnlyUserToast(
                        tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                      );
                    }}
                  />
                ) : (
                  <>
                    {tableMeta.rowData[columnIndexes.sellerAuctionUserId] !==
                    props.auctionUserId ? (
                      <>
                        {getWatchedProduct(
                          tableMeta.rowData[columnIndexes.watched],
                          tableMeta.rowData[columnIndexes.productId],
                          auctionId,
                          tableMeta.rowData[1]
                        )}
                      </>
                    ) : (
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        style={{ color: "gray" }}
                        onClick={() => {
                          renderReadOnlyUserToast(
                            tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                          );
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div
                title={`Share Product`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  shareButtonAction(
                    tableMeta.rowData[columnIndexes.productId],
                    tableMeta.rowData[columnIndexes.productStartDate]
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faShareSquareProps}
                  style={{ color: "#014a99" }}
                />
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "productEndDate",
      label: `${t("common:newCommanTrans:timeleft")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (tableMeta.rowData[columnIndexes?.productExtended] !== undefined) {
            if (tableMeta.rowData[columnIndexes.productExtended]) {
              return (
                <span style={{ color: "red" }}>{productTimeLeft(value)}</span>
              );
            } else {
              return <span>{productTimeLeft(value)}</span>;
            }
          }
        },
      },
    },
    {
      name: "code",
      label: `${t("common:Tender:tableColumnNames:sku")}`,
      options: {
        filter: true,
        sort: false,
        filterType: "textField",
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <span
              className="linkCss"
              onClick={() =>
                openProductDetail(
                  auctionId,
                  tableMeta.rowData[1],
                  tableMeta.rowData[columnIndexes.productStartDate]
                )
              }
              onContextMenu={(event: any) =>
                rightClickEvent(
                  event,
                  tableMeta.rowData[1],
                  tableMeta.rowData[columnIndexes.productStartDate]
                )
              }
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "lab",
      label: `${t("common:Tender:tableColumnNames:lab")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (
            tableMeta.rowData[columnIndexes.lab] !== "AGT" &&
            tableMeta.rowData[columnIndexes.lab] !== "agt" &&
            tableMeta.rowData[columnIndexes.lab] !== "" &&
            tableMeta.rowData[columnIndexes.lab] !== undefined
          ) {
            return (
              <span
                className="linkCss"
                onClick={() =>
                  openJewelleryCertificateLinkPopup(
                    tableMeta.rowData[columnIndexes.lab],
                    tableMeta.rowData[columnIndexes.certificate]
                  )
                }
              >
                {value}
              </span>
            );
          } else {
            return <span>{value}</span>;
          }
        },
      },
    },
    {
      name: "certificate",
      label: `${t("common:Tender:tableColumnNames:certification")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "jewelleryDetails",
      label: `${t("common:Tender:tableColumnNames:description")}`,
      options: {
        filter: false,
        sort: false,
        filterType: "textField",
        customBodyRender: (value: any) => {
          return (
            <EllipsisText
              text={getDescription(value)}
              length={50}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "currency",
      label: "currency",
      options: {
        display: false,
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return <div>{value.code}</div>;
        },
      },
    },
    {
      name: "remarks",
      label: `${t("common:Tender:tableColumnNames:remark")}`,
      options: {
        filter: true,
        sort: false,
        filterType: "textField",
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <EllipsisText
              text={getRemarks(tableMeta.rowData[columnIndexes.remarks])}
              length={50}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "notes",
      label: `${t("common:Tender:tableColumnNames:notes")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "caratMinimumPrice",
      label: `${t("common:Tender:tableColumnNames:jewelleryPrice")}`,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "myLatestBid",
      label: `${t("common:Tender:tableColumnNames:placeBid")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {isDataRefresh ? (
                <div>
                  {handelMyBidsLabel(
                    myLatestBidForProduct,
                    tableMeta.rowData[columnIndexes.productId],
                    tableMeta.rowData[columnIndexes.currency],
                    tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                  )}
                </div>
              ) : (
                <div>
                  {handelMyBidsLabel(
                    myLatestBidForProduct,
                    tableMeta.rowData[columnIndexes.productId],
                    tableMeta.rowData[columnIndexes.currency],
                    tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                  )}
                </div>
              )}
              {getBidNowButtonDisable(
                tableMeta.rowData[columnIndexes.sellerAuctionUserId],
                props.auctionUserId,
                tableMeta.rowData[columnIndexes.auctionUserId],
                tableMeta,
                getReturnMyLatestStoredBid(
                  myLatestBidForProduct,
                  tableMeta.rowData[columnIndexes.productId]
                ),
                tableMeta.rowData[columnIndexes.currentBidPrice],
                tableMeta.rowData[columnIndexes.productId],
                tableMeta.rowData[columnIndexes.previousHighestBidder],
                tableMeta.rowData[columnIndexes.holdPreviousBidder]
              )}
            </>
          );
        },
      },
    },
    {
      name: "currentBidPrice",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "noOfBidders",
      label: `${t("common:newCommanTrans:noOfBiddersBids")}`,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {getNoOfBiddersAndNoOfBids(
                tableMeta.rowData[columnIndexes.noOfBids],
                tableMeta.rowData[columnIndexes.noOfBidders]
              )}
            </div>
          );
        },
      },
    },

    {
      name: "rowColor",
      label: "Bid Color",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "exchangeRates",
      label: "Exchange Rate",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any) => {
          return <div>{value[0].rate}</div>;
        },
      },
    },
    {
      name: "myLatestBid",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "currentBidPrice",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "noOfBids",
      label: "",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "watched",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "sellerAuctionUserId",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "tenderSecondHighestBid",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "previousHighestBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productStartDate",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productExtended",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "holdPreviousBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
  ];
  const renderAutomaticBidPopup = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = mybidProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data.rowData;
      details = indexOfProduct;

      length = mybidProducts.length;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentJewelleryProductIdOfBidNow");
    }
  };
  const renderAutomaticBidPopupInMobile = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = mybidProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data;
      length = mybidProducts.length;
      details = indexOfProduct;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentJewelleryProductIdOfBidNow");
    }
  };
  const getBidNowButtonDisable = (
    sellerId: any,
    auctionUserIdForProduct: any,
    tableAuctionUserId: any,
    tableDataForUIBox: any,
    myBidsForProduct: any,
    currentBidPriceForProduct: any,
    currentproductId: any,
    previousBidderId: any,
    holdPreviousBidder: any
  ) => {
    renderAutomaticBidPopup(tableDataForUIBox);
    if (isReadOnlyUser) {
      return (
        <StyledBtnContainer
          onClick={() => {
            renderReadOnlyUserToast(sellerId);
          }}
        >
          <StyledButtonGray>
            {t("common:inquiry:button:bidNow")}
          </StyledButtonGray>
        </StyledBtnContainer>
      );
    } else {
      if (sellerId === auctionUserIdForProduct) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else if (holdPreviousBidder !== undefined) {
        if (props.auctionUserId === holdPreviousBidder) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (previousBidderId !== undefined) {
        if (props.auctionUserId === previousBidderId) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (tableAuctionUserId === props.auctionUserId) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {" "}
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else {
        return (
          <StyledBtnContainer>
            <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
              {t("common:inquiry:button:bidNow")}
            </StyledButton>
          </StyledBtnContainer>
        );
      }
    }
  };

  const handelMyBidsLabel = (
    myStoredBids: any,
    currentProductId: any,
    currency: any,
    exchangeRate: any
  ) => {
    const Obj = myLatestBidForProduct.filter(
      (item: any) => item.productId === currentProductId
    );

    const mybidPriceforProducts = Obj.map((item: any) => {
      return item.productId;
    });

    return getMyLatestStoredBids(
      myLatestBidForProduct,
      currentProductId,
      currency,
      exchangeRate,
      mybidPriceforProducts
    );
  };

  const getMyLatestStoredBids = (
    productBids: any,
    productIdFromData: any,
    currencyCodeVal: any,
    exchangeRate: any,
    otherID: any
  ) => {
    if (otherID !== undefined) {
      if (otherID[0] === productIdFromData) {
        return productBids?.map((items: any) => {
          const { productId, myLatestBid } = items;
          if (productId === productIdFromData) {
            let userCurrencyCode = localStorage.getItem("preferredCurrency");
            let userCurrencySymbol = localStorage.getItem(
              "preferredCurrencySymbol"
            );
            if (userCurrencyCode !== currencyCodeVal.code) {
              let conversion = new Intl.NumberFormat("us-en").format(
                Math.round(myLatestBid * exchangeRate)
              );
              let conversions = new Intl.NumberFormat("us-en").format(
                Math.round(myLatestBid)
              );
              return `${currencyCodeVal.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`;
            } else {
              let conversions = new Intl.NumberFormat("us-en").format(
                Math.round(myLatestBid)
              );
              return `${userCurrencySymbol} ${conversions}`;
            }
          }
        });
      } else {
        return "0";
      }
    }
  };

  //get Watched Product
  const getWatchedProduct = (
    watched: any,
    productId: any,
    auctionId: any,
    serialNo: any
  ) => {
    if (watched === true) {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => removeFromWatchlist(productId, auctionId)}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "gray" }}
          onClick={() => addToWatchList(productId, auctionId)}
        />
      );
    }
  };

  const addToWatchList = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/watch`,
        "payload",
        (status: any, response: any) => {
          if (response !== undefined) {
            if (status === 200) {
              callApi(payload);
              setIsLoading(false);
              setOnAction(false);
              setShowAlertMessage(`${t("common:preview:addedToWatchMsg")}`);
              setAlertType("success");
              setOpenToast(true);
            }
          }
        }
      );
    }
  };

  const removeFromWatchlist = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (Auth.loggedIn() === null) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/unwatch`,
        "payload",
        (status: any, response: any) => {
          if (status === 200) {
            callApi(payload);
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response.data.message);
            setAlertType("success");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const shareButtonAction = (perId: any, productStartDate: any) => {
    date = productStartDate.split(" ", 2);
    let languageCode =
      localStorage.getItem("language") === "EN"
        ? "en"
        : localStorage.getItem("language") === "zh_CN"
        ? "zh_CN"
        : "jp";
    copy(
      `${window.location.hostname}/${languageCode}/product/jewellery/${perId}/${date[0]}/detail`
    );
    setAlertType("success");
    setOpenToast(true);
    setShowAlertMessage(`${t("common:preview:linkCopied")}`);
    setTimeout(() => {
      setOpenToast(false);
    }, 2000);
  };

  const getNoOfBiddersAndNoOfBids = (noOfBidders: any, noOfBids: any) => {
    return `${noOfBidders}/${noOfBids}`;
  };

  const getRemarks = (remarks: any) => {
    if (remarks !== "" && remarks !== undefined && remarks !== null) {
      return remarks;
    } else {
      return "";
    }
  };

  const openProductDetail = (
    auctionId: string,
    perId: string,
    productStartDate: string
  ) => {
    date = productStartDate.split(" ", 2);
    history.push(
      `/365products/details/${auctionId}/${props.auctionUserId}/${perId}/${date[0]}?auctionType=Jewellery`
    );
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const openDetailsView = (
    auctionId: string,
    perId: string,
    productStartDate: string
  ) => {
     const language = localStorage.getItem("language");

     const languageCode =
       language === "EN" ? "en" : language === "zh_CN" ? "zh_CN" : "jp";
    date = productStartDate.split(" ", 2);
    window.open(
      `/${languageCode}/365products/details/${auctionId}/${props.auctionUserId}/${perId}/${date[0]}?auctionType=Jewellery`,
      "_blank"
    );
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const rightClickEvent = (
    event: React.MouseEvent<HTMLDivElement>,
    productId: string,
    productStartDate: string
  ) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
    setCurrentProductId(productId);
    setProductStartDate(productStartDate);
  };

  const handleClose = () => {
    setMouseState(initialState);
  };

  const getDescription = (jewelleryDetails: any) => {
    var jewelleryType: string = "";
    var jewelleryCondition: string = "";
    var jewelleryDescription: string = "";
    if (jewelleryDetails !== undefined && jewelleryDetails !== null) {
      if (
        jewelleryDetails.jewelleryType !== undefined &&
        jewelleryDetails.jewelleryType !== null
      ) {
        jewelleryType = jewelleryDetails.jewelleryType;
      } else {
        jewelleryType = "";
      }

      if (
        jewelleryDetails.jewelleryCondition !== undefined &&
        jewelleryDetails.jewelleryCondition !== null
      ) {
        jewelleryCondition = jewelleryDetails.jewelleryCondition;
      } else {
        jewelleryCondition = "";
      }

      if (
        jewelleryDetails.jewelleryDescription !== undefined &&
        jewelleryDetails.jewelleryDescription !== null
      ) {
        jewelleryDescription = jewelleryDetails.jewelleryDescription;
      } else {
        jewelleryDescription = "";
      }
    }

    return (
      jewelleryType + " " + jewelleryCondition + " " + jewelleryDescription
    );
  };

  const exportExcel = () => {
    let exportProductIds = mybidProducts.slice(0, 1).map((item: any) => {
      return item.auctionId;
    });
    Auth.postRequestForExcel(
      `${productDownload}?auctionId=${exportProductIds}&auctionType=Annual&auctionProductsType=mybids`,
      { ids: "" },
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            const url = window.URL.createObjectURL(
              new Blob([response], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Products.xlsx`);
            document.body.appendChild(link);
            link.click();
          }
        } else {
          //todo
        }
      }
    );
  };

  const ShowAllProduct = (auctionId: string | number) => {
    if (uiBoxView) {
      getBody(auctionId, 0, 1000, true);
    } else {
      getBody(auctionId, 0, 1000, false);
    }
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        getExtendedTime();
        return <span>00:00:00:00</span>;
      }
    } else {
      return (
        <span>
          {days}:{hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  const getExtendedTime = () => {
    // if (countAnnualRef.current < maxCallApiCount) {
    //   getTendorMybidsAucProducts(auctionId, 0, false);
    //   closebidPopup();
    //   countAnnualRef.current = countAnnualRef.current + 1;
    // }
    if (!countAnnualRef.current) {
      if (secondTryAnnualRef.current === 0) {
        getTendorMybidsAucProducts(auctionId, 0, false);
      } else {
        getTendorMybidsAucProductsFirst(auctionId, 0, false);
      }
      countAnnualRef.current = countAnnualRef.current + 1;
    }
    closebidPopup();
  };

  const getExtendedTimeGrid = (pagenum: any) => {
    if (!countAnnualRef.current) {
      if (secondTryAnnualRef.current === 0) {
        getTendorMybidsAucProducts(auctionId, pagenum, true);
      } else {
        getTendorMybidsAucProductsFirst(auctionId, pagenum, true);
      }
      countAnnualRef.current = countAnnualRef.current + 1;
    }
    closebidPopup();
  };

  const productTimeLeft = (startDate: any) => {
    let date: string | null = "";
    let time: string | null = "";
    let timezone: any = "";

    if (startDate !== null || startDate !== undefined) {
      let previewTime = moment.utc(startDate);
      if (timezone !== null) {
        timezone = localStorage.getItem("timezoneName");
      }
      if (previewTime !== null || previewTime !== undefined) {
        let result = moment.tz(previewTime, timezone);
        let resultFormatter = result.format();
        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";
          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }
          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          //let start: any = moment(dateTime);
          let end: any = moment(dateTime);
          timezone = localStorage.getItem("timezoneName");
          //let end: any = moment(new Date().toLocaleString("en-US", { timeZone: timezone }));
          let start: any = moment(
            new Date().toLocaleString("en-US", { timeZone: timezone })
          );
          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
        }
      }
    }
    return (
      <Countdown
        date={Date.now() + seconds}
        className="countdownText"
        renderer={renderer}
        zeroPadTime={2}
      />
    );
  };

  //Auction end popup redirection funtion
  const setItemsPerPageHandler = (itemsPerPage: number) => {
    setCurrentPage(1);
    jwlItemPerPageRefmybid.current = itemsPerPage;
    setItemsPerPage(itemsPerPage);
  };
  function setCurrentPage(currentPage: number) {
    return currentPage;
  }

  function setItemsPerPage(itemsPerPage: number) {
    return itemPerPage(true, 0, itemsPerPage);
  }
  const itemPerPage = (value: boolean, start: number, itemPerPage: number) => {
    if (value === true) {
      localStorage.setItem("annualitemsPerPage", JSON.stringify(itemPerPage));
      getUpdatedProducts(value, start, itemPerPage);
    }
  };

  const getUpdatedProducts = (value: any, start: any, endRecords: any) => {
    if (value === true) {
      getProducts(start, endRecords);
    }
  };

  const getProducts = (start: number, end: number) => {
    startCount = start;
    endCount = end;
    localStorage.setItem("currentStart", JSON.stringify(start));
    localStorage.setItem("onlyMybidsCurrentStart", JSON.stringify(start));
    let Page: any = localStorage.getItem("jwlcurrentPageOfTenderAllProducts");
    dispatch(resetGridProductIndexes());
    dispatch(resetjewellerySelectAll());
    // PubSub.publish("jewellerySelectAllCheckBoxMybids", { isItemSelected: false, selectedIndexes: [] });
    getBody(auctionId, parseInt(Page), endCount, true);
    PubSub.publish("resetAnnualGridBoxIndex", []);

    onGridSelectionChange(0);
    setIsSelected(false);
    setIsLoading(true);
  };

  const theme = useTheme();
  const notSmallDevices = useMediaQuery(theme.breakpoints.between("md", "xl"));
  let isAuctionPage: any = true;

  const closebidPopup = () => {
    setshowTenderSlider(false);
    setShowBulkBidPopup(false);
  };

  let isCategoryPageType: any = false;

  const handleMyBids = () => {
    //todo
  };

  const watchlist = () => {
    localStorage.removeItem("selectedFilterSort");
    PubSub.publish("resetAnnualGridBoxIndex", []);
    date = auctionDate.split(" ", 2);
    history.push(
      `/watchlist/${auctionId}/${props.auctionUserId}/${date[0]}/Annual`
    );
    localStorage.removeItem("onlyMybidsCurrentStart");
    localStorage.removeItem("annualitemsPerPage");
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  const filterColorSort = () => {
    //todo
    if (!isColorDataFilter) {
      setmybidProducts(
        mybidProducts.sort((a: any, b: any) =>
          a.sortingColorCode > b.sortingColorCode ? 1 : -1
        )
      );
    } else {
      setmybidProducts(
        mybidProducts.sort((a: any, b: any) =>
          a.sortingColorCode < b.sortingColorCode ? 1 : -1
        )
      );
    }
    setIsColorDataFilter(!isColorDataFilter);
  };

  const filterSort = (price: any, direction: any) => {
    let order = "";
    if (direction === "asc") {
      order = "desc";
    } else {
      order = "asc";
    }
    sort(price, order);
  };

  const sort = (value: any, direction: any) => {
    sortData(value, direction);
  };

  const sortData = (values: any, direction: any) => {
    let tempArr: any = [{ property: values, direction: direction }];

    if (direction === "asc") {
      tempArr = [{ property: values, direction: "ASC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    } else {
      tempArr = [{ property: values, direction: "DESC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    }

    if (localStorage.getItem("onlyMybidsCurrentStart") === null) {
      localStorage.setItem("onlyMybidsCurrentStart", "0");
    } else {
      localStorage.removeItem("onlyMybidsCurrentStart");
    }
    getTendorMybidsAucProducts(auctionId, 0, true);
  };

  const listGridview = () => {
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
    // jwlItemPerPageRefmybid.current = 0
    if (localStorage.getItem("onlyMybidsCurrentStart") === null) {
      localStorage.setItem("onlyMybidsCurrentStart", "0");
    } else {
      localStorage.removeItem("onlyMybidsCurrentStart");
    }
    localStorage.removeItem("annualitemsPerPage");

    getTendorMybidsAucProducts(auctionId, 0, true);
    setUiBoxView(true);
    dispatch(setJwlIsGridView({ gridView: true }));
  };

  const Gridview = () => {
    getBody(auctionId, 0, 100, false);
    setUiBoxView(false);
    dispatch(resetJwlIsGridView());
    onGridSelectionChange(0);
    PubSub.publish("resetAnnualGridBoxIndex", []);
  };

  useEffect(() => {
    let isShowDrawerIcon: any = localStorage.getItem("isShowDrawerIcon");
    isShowDrawerIcon = JSON.parse(isShowDrawerIcon);
    if (isShowDrawerIcon !== null) {
      if (isShowDrawerIcon) {
        const accordionHeader: any = document.querySelector(".AccordionHeader");
        if (accordionHeader !== null) {
          accordionHeader.style.width = isShowDrawerIcon
            ? "calc(100% - 60px) !important"
            : "calc(100% - 240px) !important";
        }
      }
    }
  });

  const renderReadOnlyUserToast = async (id: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any, index: number) => {
        if (items.category === "Jewellery") {
          if (id === items.auctionUserId) {
            isAuctionUserId = true;
          }
        }
      });
    } else {
      isAuctionUserId = false;
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const colorMybidsFilter = (e: any) => {
    setColorMybidsName(e.target.value);
    const value = e.target.value;
    localStorage.setItem("onlyMybidsCurrentStart", "0");
    dispatch(setColorFilter({ color: value }));
  };

  useEffect(() => {
    let innerwidth: any = window.innerWidth;
    if (innerwidth > 700) {
      if (isGridView) {
        getTendorMybidsAucProducts(auctionId, 0, true);
      } else {
        getBody(auctionId, 0, 100, false);
      }
    } else {
      getTendorMybidsAucProducts(auctionId, 0, true);
    }
  }, [selectedColor]);

  useEffect(() => {
    let totalpay = 0;
    // return filtred array
    let filtredArr =
      colorMybidsName !== "ALL"
        ? mybidProducts?.filter((x: any) => x.colorFilter === colorMybidsName)
        : mybidProducts;
    //calculate total sum of current Bid Price
    filtredArr?.map((x: any) => {
      totalpay = totalpay + x.currentBidPrice;
    });
    bufferTotalPay.current = totalpay;
    setTotalAmount(totalpay);
  }, [colorMybidsName]);

  const selectAllInGridView = () => {
    //calling select all function in grid View
    let arr: any = [];
    mybidProducts.map((productVal: any, index: any) => {
      if (arr.length < 10) {
        if (isReadOnlyUser) {
          //
        } else {
          if (productVal.sellerAuctionUserId === props.auctionUserId) {
            //
          } else if (productVal.holdPreviousBidder !== undefined) {
            if (props.auctionUserId === productVal.holdPreviousBidder) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          } else if (productVal.previousBidderId !== undefined) {
            if (props.auctionUserId === productVal.previousBidderId) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          } else if (productVal.auctionUserId === props.auctionUserId) {
            //
          } else {
            if (productVal.auctionUserId === props.auctionUserId) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          }
        }
      }
    });
    if (isSelected) {
      setIsSelected(false);
      PubSub.publish("resetAnnualGridBoxIndex", []);
      arr = [];
      dispatch(resetGridProductIndexes());
      dispatch(resetjewellerySelectAll());
    } else {
      setIsSelected(true);
      dispatch(setGridProductIndexes({ indexes: arr }));
      dispatch(setjewellerySelectAll({ isSelected: true }));
    }
  };

  // buy it now button condition
  useEffect(() => {
    if (currentProductData !== null) {
      setIsBuyItNowModal(true);
    }
  }, [!currentProductData]);

  const renderBuyItNowConfirmationModal = () => {
    return (
      <StyledModal
        open={isBuyItNowModal}
        onClose={() => {
          setCurrentProductData(null);
          setIsBuyItNowModal(false);
        }}
      >
        <BuyItNowconfirmation
          closeModal={() => {
            setCurrentProductData(null);
            setIsBuyItNowModal(false);
          }}
          itemDetails={currentProductData}
          auctionUserId={props.auctionUserId}
        />
      </StyledModal>
    );
  };

  return (
    <StyledLayoutGrid>
      {isLoading === true ? (
        <div className="loader">
          <LoadingSpinner />
        </div>
      ) : (
        <StyledLayoutGridMain>
          <StyledLayoutGrid item={true} xs={12}>
            <StyledHeaderContainer container={true} spacing={0}>
              <StyledCoreDataGridContainer container={true} spacing={0}>
                <StyledActionBarContainer
                  container={true}
                  spacing={0}
                  className="coreActionBarContainer"
                >
                  <StyledContainer>
                    {notSmallDevices ? (
                      <>
                        {isGridView === true ? (
                          <StyledSelectAllButtonHeader
                            onClick={selectAllInGridView}
                          >
                            {t("common:newCommanTrans:selectAll")}
                          </StyledSelectAllButtonHeader>
                        ) : null}
                      </>
                    ) : (
                      <StyledSelectAllButtonHeader
                        onClick={selectAllInGridView}
                      >
                        {t("common:newCommanTrans:selectAll")}
                      </StyledSelectAllButtonHeader>
                    )}
                    <StyledPageSizeSelectorContainer>
                      {/* <SelectBox filterFunction={fillterApiCalling}/> */}
                      <select
                        name="sortingControl"
                        onChange={colorMybidsFilter}
                        value={colorMybidsName}
                      >
                        <option value="ALL">----mybids---</option>
                        <option value="ALL">
                          {t("common:colorFilter:all")}
                        </option>
                        <option value="PINK">
                          {t("common:colorFilter:pink")}
                        </option>
                        <option value="ORANGE">
                          {t("common:colorFilter:orange")}
                        </option>
                        <option value="WHITE">
                          {t("common:colorFilter:white")}
                        </option>
                      </select>
                    </StyledPageSizeSelectorContainer>
                    <StyledButtonHeader onClick={productCart}>
                      {t("common:newCommanTrans:Cart")}
                    </StyledButtonHeader>
                    <StyledButtonHeader onClick={watchlist}>
                      {t("common:menu:watchlist")}
                    </StyledButtonHeader>
                    <StyledButtonHeader onClick={exportExcel}>
                      {t("common:preview:pagination:export")}
                    </StyledButtonHeader>
                  </StyledContainer>
                  <StyledContainer>
                    {showBulkBidButton === true ? (
                      <StyledButtonHeader
                        onClick={bulkBidPopupHandler}
                        style={{ width: "100%" }}
                      >
                        {t("common:preview:tendor:bulkBid")}
                      </StyledButtonHeader>
                    ) : (
                      <></>
                    )}
                  </StyledContainer>

                  {notSmallDevices ? (
                    <>
                      {isGridView === true ? (
                        <AnnualActionPageSizeSelectorjwl
                          setItemsPerPageHandler={setItemsPerPageHandler}
                          t={t}
                        />
                      ) : null}
                    </>
                  ) : (
                    <AnnualActionPageSizeSelectorjwl
                      setItemsPerPageHandler={setItemsPerPageHandler}
                      t={t}
                    />
                  )}
                  {notSmallDevices ? (
                    <>
                      {isGridView === true ? (
                        <StyledButtonView onClick={Gridview}>
                          <Styledview src="/images/view/listView.png" />
                        </StyledButtonView>
                      ) : (
                        <StyledButtonView onClick={listGridview}>
                          <Styledview src="/images/view/gridview.jpeg" />
                        </StyledButtonView>
                      )}
                    </>
                  ) : null}
                  <StyledButtonViewFilter onClick={filterColorSort}>
                    <ColorLensIcon />
                  </StyledButtonViewFilter>
                </StyledActionBarContainer>
              </StyledCoreDataGridContainer>
            </StyledHeaderContainer>
            <div style={{ float: "right", width: "100%", display: "flex" }}>
              {t("common:newCommanTrans:totalAmounts")}:{" "}
              <span style={{ color: "green" }}>{totalAmountLabel}</span>
            </div>
            <div>
              {mybidProducts.length > 0 ? (
                <>
                  {isGridView === false && notSmallDevices && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={""}
                        data={mybidProducts}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  )}

                  {isGridView === true ? (
                    notSmallDevices && (
                      <>
                        <JwlProductGridDataParentjwl
                          t={t}
                          data={mybidProducts}
                          totalElements={totalElement}
                          itemPerPage={itemPerPage}
                          value={getUpdatedProducts}
                          noProductFound={handleMyBids}
                          jwlItemPerPageRef={jwlItemPerPageRefmybid.current}
                          selectJwlPageUseRef={selectPageUseRef.current}
                        >
                          {mybidProducts.length > 0 ? (
                            <ProductGridDataChildComponentMyBids
                              {...props}
                              watchlist={addToWatchList}
                              unWatchlist={removeFromWatchlist}
                              setShowBidPopupBidModal={getBoxIndex}
                              auctionName={auctionName}
                              auctionDate={date[0]}
                              t={t}
                              isAuctionPage={isAuctionPage}
                              isCategoryPageType={isCategoryPageType}
                              boxColor={boxColor}
                              auctionUserId={props.auctionUserId}
                              sortingValue={filterSort}
                              bulkBidIndexHandler={onGridSelectionChange}
                              myForProductAllProduct={myLatestBidForProduct}
                              renderAutomaticBidPopupInMobile={
                                renderAutomaticBidPopupInMobile
                              }
                              renderReadOnlyUserToast={renderReadOnlyUserToast}
                              isRefreshData={getExtendedTimeGrid}
                              rightClickEvent={rightClickEvent}
                            />
                          ) : (
                            <Grid container={true} spacing={0}>
                              <StyledTextWrapper item xs={12}>
                                {t("common:preview:noProductFound")}
                              </StyledTextWrapper>
                            </Grid>
                          )}
                        </JwlProductGridDataParentjwl>
                      </>
                    )
                  ) : (
                    <></>
                  )}

                  {notSmallDevices || (
                    <>
                      <JwlProductGridDataParentjwl
                        t={t}
                        data={mybidProducts}
                        totalElements={totalElement}
                        itemPerPage={itemPerPage}
                        value={getUpdatedProducts}
                        noProductFound={handleMyBids}
                        jwlItemPerPageRef={jwlItemPerPageRefmybid.current}
                        selectJwlPageUseRef={selectPageUseRef.current}
                      >
                        {mybidProducts.length > 0 ? (
                          <ProductGridDataChildComponentMyBids
                            {...props}
                            watchlist={addToWatchList}
                            unWatchlist={removeFromWatchlist}
                            setShowBidPopupBidModal={getBoxIndex}
                            auctionName={auctionName}
                            auctionDate={date[0]}
                            t={t}
                            isAuctionPage={isAuctionPage}
                            boxColor={boxColor}
                            isCategoryPageType={isCategoryPageType}
                            auctionUserId={props.auctionUserId}
                            sortingValue={filterSort}
                            bulkBidIndexHandler={onGridSelectionChange}
                            myForProductAllProduct={myLatestBidForProduct}
                            renderAutomaticBidPopupInMobile={
                              renderAutomaticBidPopupInMobile
                            }
                            renderReadOnlyUserToast={renderReadOnlyUserToast}
                            isRefreshData={getExtendedTimeGrid}
                            rightClickEvent={rightClickEvent}
                          />
                        ) : (
                          <Grid container={true} spacing={0}>
                            <StyledTextWrapper item xs={12}>
                              {t("common:preview:noProductFound")}
                            </StyledTextWrapper>
                          </Grid>
                        )}
                      </JwlProductGridDataParentjwl>
                    </>
                  )}
                  {notSmallDevices ? (
                    <>
                      {isGridView === false && (
                        <StyeldShowAllcontainer container={true} spacing={0}>
                          {showAllProductButton ? (
                            <StyledshowAllButton>
                              <StyledButton
                                onClick={() => ShowAllProduct(auctionId)}
                              >
                                {t("common:Tender:button:showAll")}
                              </StyledButton>
                            </StyledshowAllButton>
                          ) : (
                            <></>
                          )}
                        </StyeldShowAllcontainer>
                      )}
                    </>
                  ) : null}
                </>
              ) : (
                <Grid container={true} spacing={0}>
                  {notSmallDevices ? (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={""}
                        data={mybidProducts}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  ) : (
                    <StyledTextWrapper item xs={12}>
                      {t("common:preview:noProductFound")}
                    </StyledTextWrapper>
                  )}
                </Grid>
              )}
            </div>
            <Menu
              keepMounted
              open={mouseState.mouseY !== null}
              onClose={handleClose}
              anchorReference="anchorPosition"
              anchorPosition={
                mouseState.mouseY !== null && mouseState.mouseX !== null
                  ? { top: mouseState.mouseY, left: mouseState.mouseX }
                  : undefined
              }
            >
              <MenuItem
                onClick={() =>
                  openDetailsView(auctionId, currentProductId, productdate)
                }
              >
                Details
              </MenuItem>
            </Menu>
            {openToast === true && (
              <Alert
                showAlertMessage={showAlertMessage}
                alertType={alertType}
              />
            )}
            {onAction === true && (
              <div className="loading">
                <LoadingSpinner />
              </div>
            )}
            {showTenderSlider === true && (
              <StyledModal open={showTenderSlider} onClose={closebidPopup}>
                <ProductBiddingUi
                  {...props}
                  items={mybidProducts}
                  currentIndex={details}
                  PopupClose={closebidPopup}
                  handleBtnValue={handleBtnValue}
                  auctionDate={date[0]}
                  totalElements={totalElement}
                  endCount={endCount}
                  auctionUserId={props.auctionUserId}
                  length={length}
                  watchedFunction={addToWatchList}
                  unwatched={removeFromWatchlist}
                  boxColor={boxColor}
                />
              </StyledModal>
            )}
            {showBulkBidPopup === true && (
              <StyledModal open={showBulkBidPopup} onClose={closebidPopup}>
                <AnnualBidPopup
                  {...props}
                  items={mybidProducts}
                  popupClose={closebidPopup}
                  handleBtnValue={bulkBidHandler}
                  auctionUserId={props.auctionUserId}
                  length={length}
                  productIndexs={indexsForBulkBidItems}
                  myLatestBidForProducts={myLatestBidForProduct}
                  isJewellery={true}
                />
              </StyledModal>
            )}
            {openReadOnlyUserToast === true && (
              <AlertReadOnlyUser
                isReadOnlyUser={isReadOnlyUser}
                isSeller={isAuctionUserId}
              />
            )}
            {isBuyItNowModal &&
              currentProductData !== null &&
              renderBuyItNowConfirmationModal()}
          </StyledLayoutGrid>
        </StyledLayoutGridMain>
      )}
    </StyledLayoutGrid>
  );
};

export default JwlProductMyBids;
